import styles from "./ParentReports.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";

import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import IconAndName from "../../components/IconAndName/IconAndName";
import { FaUserPlus } from "react-icons/fa";
import { LuClock3 } from "react-icons/lu";
import CopyRight from "../../components/CopyRight/CopyRight";

const data = [
  {
    _id: "1",
    studentName: "John Jacob",
    parentOne: "Name 1",
    parentTwo: "Name 1",
  },
  {
    _id: "2",
    studentName: "John Jacob",
    parentOne: "Name 2",
    parentTwo: "Name 2",
  },
  {
    _id: "3",
    studentName: "John Jacob",
    parentOne: "Name 3",
    parentTwo: "Name 3",
  },
  {
    _id: "4",
    studentName: "John Jacobhj",
    parentOne: "Name 4",
    parentTwo: "Name 4",
  },
];
  

function ParentReports() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const handleAddProgram = () => {
    dispatch(openModal("addProgram"));
  };
  const handleSendInvite = (item) => {
    // Later you can dispatch modal or API call here
    console.log("Send invite clicked for:", item.studentName);
  };
  
  const handleSendParentInviteModal = () => {
    dispatch(openModal("mailInviteParentSend"));
  };
  

  const getColumnData = (data) => {
    return data?.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        studentName: item.studentName,
        parentOne: item.parentOne,
        parentTwo: item.parentTwo,
        invite: (
          <div
            style={{ color: "var(--Primary_Color)", cursor: "pointer" ,padding:"0.3rem 0", width : 'max-content'}}
            onClick={() => handleSendInvite(item)}
          >
            Send
          </div>
        ),
      };
    });
  };
  

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Student Name", accessor: "studentName" },
    { title: "Parent One", accessor: "parentOne" },
    { title: "Parent Two", accessor: "parentTwo" },
    { title: "Invite", accessor: "invite" },
  ];
  

  const displayData = getColumnData(data);



  return (
    <div className={styles.copyright}>
      <div className={styles.programcontainer}>
        <div className={styles.container}>
          <div className={styles.cardsrow}>
            <div className={styles.resultandcount}>
              <ResultAndCount
                label="Parents With Installation"
                count={10}
                bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
                textColor="Black_Color"
              />
              <ResultAndCount
                label="Parents Without Installation"
                count={2}
                bgColor="rgba(from var(--Primary_Color) r g b / 0.35)"
                textColor="Black_Color"
              />
            </div>
            <div className={styles.inviteButtonWrapper}>
              <IconAndName
                title="Send Email Invite"
                bgColor="Primary_Color"
                onClick={handleSendParentInviteModal}
              />

              <Action
                options={["Edit email invite", "Invitation log"]}
                onSelect={(opt) => {
                  if (opt === "Edit email invite") {
                    dispatch(openModal("mailInviteParentEdit"));
                  } else if (opt === "Invitation log") {
                    console.log("Open invitation log");
                  }
                }}
              />
            </div>
          </div>

          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search by Staff Name"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.dropdown}>
                <Dropdown label="Student Status" options={["Room1", "Room2"]} />
              </div>
            </div>

            <div className={styles.dynamicdata}>
              <Dynamic
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>

            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default ParentReports;
